import { BASE_URL } from "config";
import * as baseApi from "./_base";

export const endpoints = {
    list: `${BASE_URL}/api/v1/billing/balance/`,
    detail: (id) => `${BASE_URL}/api/v1/billing/balance/${id}/`,
};

export const balanceListLoad = (token, payload) => baseApi.ListLoad(endpoints.list, token, payload);
export const balanceDetailLoad = (token, { id }) => baseApi.DetailLoad(endpoints.detail, token, { id });
export const balanceUpdate = (token, data) => baseApi.Update(endpoints.list, endpoints.detail, token, data);
